/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
/** @jsx jsx */
import { jsx, Box, Container, Flex } from 'theme-ui';
/* eslint-disable react/no-danger */
import React from 'react';

// Node Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';

// Node Components
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';

// Types
import { CTA } from '../../@types/cta';
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';

// Components
import Text, { TEXT_TYPES } from '../../components/text';
import CTAButton from '../../components/ctaButton';

// Styles
import { baseStyle } from './style';

interface ImageAndTitleText2ColsProps extends Section {
  chooseTheImageSide: {
    side?: string;
  };
  cta: CTA;
  image: {
    image?: ImageType;
  };
  mobile: {
    mobileImage?: ImageType;
  };
  sub: {
    subTitle?: string;
  };
  text: {
    content?: string;
  };
  title: {
    title: string;
  };
}

const ImageAndTitleText2Cols: SectionComponent<ImageAndTitleText2ColsProps> = React.memo(
  ({ chooseTheImageSide, cta, image, mobile, sub, text, title }) => {
    // Memos
    const orders = React.useMemo(() => {
      if (chooseTheImageSide?.side) {
        return chooseTheImageSide.side.trim().toLowerCase() === 'left'
          ? [1, 2]
          : [2, 1];
      }
      return [1, 2];
    }, [chooseTheImageSide]);

    return (
      <Container sx={baseStyle.mainContainer}>
        <Flex sx={baseStyle.flexContainer}>
          <Box
            className={orders[0] === 1 ? 'left-col' : ''}
            sx={{ ...baseStyle.imageContainer, order: orders[0] }}
          >
            <FluidImage {...image?.image} sx={baseStyle.image} />
          </Box>
          <Box
            className={orders[0] === 2 ? 'left-col' : ''}
            sx={{ ...baseStyle.contentContainer, order: orders[1] }}
          >
            <Text type={TEXT_TYPES.H2} sx={baseStyle.contentTitle} lines="1">
              {title.title}
            </Text>
            {sub.subTitle && (
              <Text
                type={TEXT_TYPES.H4}
                sx={baseStyle.contentSubtitle}
                lines="1"
              >
                {sub.subTitle}
              </Text>
            )}
            <Box sx={baseStyle.responsiveImageContainer}>
              <FluidImage
                {...(mobile?.mobileImage ?? image?.image)}
                sx={baseStyle.image}
              />
            </Box>
            {text?.content && (
              <Text
                type={TEXT_TYPES.BODY_INTRO}
                sx={baseStyle.contentContent}
                lines="6"
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html: text?.content || '',
                  }}
                />
              </Text>
            )}
            <CTAButton type="link" cta={cta} sx={baseStyle.contentCta}>
              {cta.label}
            </CTAButton>
          </Box>
        </Flex>
      </Container>
    );
  },
);

export default ImageAndTitleText2Cols;
